module.exports = __webpack_public_path__ + "img/fuli1.9b541b33.png";